import { useCallback } from 'react';
import { Button, Spinner } from '@iwoca/orion';
import clsx from 'clsx';
import { FILTER_OPTIONS } from 'components/Dashboard/DashboardHeader/QuickFilters/QuickFilters.helpers';
import { TFilter } from 'types';
import styles from './QuickFilters.module.css';
import { useQuickFilters } from './useQuickFilters.hook';

export const QuickFilters = () => {
  const { isLoading, getFilteredCount, isFilterActive, handleClick } =
    useQuickFilters();

  const renderFilter = useCallback(
    (option: TFilter) => {
      const isActive = isFilterActive(option);
      const quantity = getFilteredCount(option);
      return (
        <Button
          key={option.id}
          size="small"
          onClick={() => handleClick(option, quantity)}
          variant={isActive ? 'denim' : 'tertiary'}
          data-testid={isActive ? 'active-filter' : 'inactive-filter'}
        >
          {option.displayQuantity && (
            <div
              className={clsx(styles.applicationQuantity, styles[option.id])}
            >
              {isLoading ? (
                <Spinner
                  data-testid="filter-spinner"
                  size="small"
                  className={styles.spinner}
                />
              ) : (
                quantity
              )}
            </div>
          )}
          {option.label}
        </Button>
      );
    },
    [getFilteredCount, handleClick, isFilterActive, isLoading],
  );
  return (
    <div className={styles.filters}>
      {FILTER_OPTIONS().map((option) => renderFilter(option))}
    </div>
  );
};
